import React from "react";
import "./ExamPlanFinalDetail.scss";

function ExamPlanFinalDetail({ exam }) {
    return (
        <div className="expln-final-detail">
            <section className="expln-box expln-scholar">
                <h2 className="expln-scholar__tit">
                    기말고사 성적을 입력하고
                    <br />
                    성적 우수 장학생에 도전해 보세요!
                </h2>
                <p className="expln-scholar__date">{exam.fullPeriod}</p>
                <h3 className="expln-scholar__subtit">
                    장학생 선발 부문 <span className="expln-scholar__note">*주요과목 : 국/영/수/사/역/과</span>
                </h3>
                <dl className="expln-scholar__crit-list">
                    <div className="expln-scholar__crit">
                        <dt className="expln-scholar__term">올백상</dt>
                        <dd className="expln-scholar__desc">주요과목 100점</dd>
                        <dd className="expln-scholar__desc">성적 향상생평균 5점 또는 10점 이상 향상</dd>
                    </div>
                    <div className="expln-scholar__crit">
                        <dt className="expln-scholar__term">올백상</dt>
                        <dd className="expln-scholar__desc">주요과목 평균 98점 이상</dd>
                        <dd className="expln-scholar__desc">영수 만점생영서, 수학 모두 100점</dd>
                    </div>
                    <div className="expln-scholar__crit">
                        <dt className="expln-scholar__term">올백상</dt>
                        <dd className="expln-scholar__desc">주요과목 평균 95점 이상</dd>
                    </div>
                </dl>
            </section>
            <section className="expln-box expln-notice">
                <span className="expln-notice__tag">MISSION 0</span>
                <h2 className="expln-notice__tit">주의 사항</h2>
            </section>
        </div>
    );
}

export default ExamPlanFinalDetail;
